export default "__VITE_ASSET__874a140b__"